var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThemeIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_675",
    "data-name": "Group 675",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 24,
    height: 24,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_43",
    "data-name": "Mask Group 43",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 1.714,
    cy: 1.714,
    r: 1.714,
    transform: "translate(5.141 6.864)",
    fill: "#2ebe54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 1.714,
    cy: 1.714,
    r: 1.714,
    transform: "translate(10.282 4.293)",
    fill: "#2ebe54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 1.714,
    cy: 1.714,
    r: 1.714,
    transform: "translate(15.423 6.864)",
    fill: "#2ebe54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 1.714,
    cy: 1.714,
    r: 1.714,
    transform: "translate(16.28 12.004)",
    fill: "#2ebe54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1.714,
    cy: 1.714,
    r: 1.714,
    transform: "translate(12.852 16.289)",
    fill: "#2ebe54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M14.172,1.714a12,12,0,0,0-12.458,12,4.13,4.13,0,0,0,5.218,3.984l.96-.266a2.57,2.57,0,0,1,3.247,2.485v3.222a2.57,2.57,0,0,0,2.57,2.57,12,12,0,0,0,.463-23.991Zm6.949,19.116a10.222,10.222,0,0,1-7.412,3.162.857.857,0,0,1-.857-.857V19.913a4.284,4.284,0,0,0-4.284-4.284,4.344,4.344,0,0,0-1.14.154l-.96.266a2.416,2.416,0,0,1-3.042-2.339A10.282,10.282,0,0,1,14.112,3.427a10.436,10.436,0,0,1,9.879,9.879,10.188,10.188,0,0,1-2.87,7.531Z",
    transform: "translate(-1.714 -1.705)",
    fill: "#2ebe54"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIc);
export default __webpack_public_path__ + "static/media/themeIc.661659216f62e4a3f48a00c59e1402d1.svg";
export { ForwardRef as ReactComponent };